module.exports = __webpack_public_path__ + "img/ToucanTropics_EGM.fd60f496.jpg";